import api from './client';

export const deviceAPI = {
  getAll: async (limit?: number, offset?: number) => {
    const response = await api.get('/api/admin/devices', {
      params: { limit, offset },
    });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/api/admin/devices/${id}`);
    return response.data;
  },

  lock: async (id: number) => {
    const response = await api.post(`/api/admin/devices/${id}/lock`);
    return response.data;
  },

  unlock: async (id: number) => {
    const response = await api.post(`/api/admin/devices/${id}/unlock`);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/api/admin/devices/${id}`);
    return response.data;
  },

  getLogs: async (deviceId: number, limit?: number) => {
    const response = await api.get('/api/admin/logs', {
      params: { deviceId, limit },
    });
    return response.data;
  },
};
